import { FaqMessages } from './nl'

const en: FaqMessages = {
  'shipping-and-delivery': { title: 'Shipping and delivery', urlSlug: 'shipping-and-delivery' },
  'watch-service': { title: 'Watch service', urlSlug: 'watch-service' },
  'jewel-service': { title: 'Jewel service', urlSlug: 'jewel-service' },
  'return-and-refund': { title: 'Return and refund', urlSlug: 'return-and-refund' },
  payments: { title: 'Pay', urlSlug: 'payments' },
  stores: { title: 'Stores', urlSlug: 'stores' },
  moreQuestions: 'More questions',
}

export default en
